// Central configuration for backend API URLs
const rawBackendUrl = process.env.REACT_APP_BACKEND_URL || "http://localhost:5001";
// Normalize to avoid accidental double slashes when env includes a trailing '/'.
export const BACKEND_BASE_URL = rawBackendUrl.replace(/\/+$/, "");
export const BACKEND_API_URL = `${BACKEND_BASE_URL}/api/v1`;

